import { CHAT_FILTERS_NUDGE_STEP_KEY } from "constants/chatFilterNudge";
import { ONBOARDING_STATUS } from "constants/inkleAI";
import { useRef } from "react";
import {
  useGetOnBoardingQuery,
  useUpdateOnBoardingMutation,
} from "store/apis/inkleAI";

const PENDING_STATUSES: string[] = [
  ONBOARDING_STATUS.NOT_STARTED,
  ONBOARDING_STATUS.IN_PROGRESS,
];

type ChatFilterNudge = {
  isUnseen: boolean;
  markSeen: () => Promise<void>;
};

export const useChatFilterNudge = (): ChatFilterNudge => {
  const isMarking = useRef(false);

  const { data: productStep, isSuccess } = useGetOnBoardingQuery({
    step_key: CHAT_FILTERS_NUDGE_STEP_KEY,
  });
  const [updateOnBoarding] = useUpdateOnBoardingMutation();

  const isUnseen =
    isSuccess && PENDING_STATUSES.includes(productStep?.status_display || "");

  const markSeen = async () => {
    if (!productStep?.uuid || !isUnseen || isMarking.current) {
      return;
    }

    isMarking.current = true;

    try {
      await updateOnBoarding({
        uuid: productStep.uuid,
        step_key: CHAT_FILTERS_NUDGE_STEP_KEY,
        status: ONBOARDING_STATUS.COMPLETED,
      }).unwrap();
    } catch (error) {
      isMarking.current = false;
      console.error("Could not mark the chat filter hint as seen", error);
    }
  };

  return { isUnseen, markSeen };
};
